import { render } from "./ChangeEmailModal.vue?vue&type=template&id=497c4073"
import script from "./ChangeEmailModal.vue?vue&type=script&lang=js"
export * from "./ChangeEmailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__